import { useState } from 'react';
import { I } from '../data/tokens';
import NavIcon from './NavIcon';

const NAV_ICON = { Home: 'home', About: 'person', Projects: 'folder_open', Career: 'timeline', Contact: 'email' };

export default function Sidebar({ navItems, activeSection, scrollTo, setOpenProject }) {
  const [hovered, setHovered] = useState(null);
  return (
    <aside style={I.aside} className="aside-desktop">
      <div style={I.brand}>
        <div style={I.brandDot} />
        <span style={I.brandName}>Ismil Nadaf</span>
      </div>
      <nav style={I.nav}>
        {navItems.map((item) => {
          const active = activeSection === item.id;
          const hover  = hovered === item.id;
          const lit    = active || hover;
          return (
            <button
              key={item.id}
              style={I.navItem}
              onClick={() => { setOpenProject(null); scrollTo(item.id); }}
              onMouseEnter={() => setHovered(item.id)}
              onMouseLeave={() => setHovered(null)}
            >
              <NavIcon
                name={NAV_ICON[item.label] || 'home'}
                size={18}
                color="#1A1A1A"
                style={{
                  opacity:    lit ? 1 : 0.4,
                  transition: 'opacity 0.25s ease, transform 0.25s ease',
                  transform:  lit ? 'scale(1.05)' : 'scale(1)',
                }}
              />
              <span style={{
                ...I.navLabel,
                opacity:    lit ? 1 : 0.45,
                transform:  lit ? 'translateX(4px)' : 'translateX(0)',
                transition: 'all 0.25s ease',
              }}>
                {item.label}
              </span>
              {active && <div style={I.navIndicator} />}
            </button>
          );
        })}
      </nav>
      <div style={I.asideFooter}>
        <span style={I.asideFooterText}>Senior Product &amp; UX Design Leader</span>
        <span style={I.asideFooterText}>Pune, Maharashtra, India</span>
      </div>
    </aside>
  );
}
